import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caliper",
  "use": "caliper-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"caliper\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M11.293 7.5c.453 0 .887.18 1.207.5l6 6-.5.5-1.658-.553A5.99 5.99 0 0 1 14 12.5L11.5 15h-1L5 20.5l-2-2L8.5 13v-1l3-3L10 7.5ZM14.5 3 16 4.5l.5-.5 3 3a5.99 5.99 0 0 1 1.447 2.342L21.5 11l-.5.5-3-3-2 2-3-3 2-2-.113-.125a1.707 1.707 0 0 1-.387-1.082V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol